var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('app-sub-title',{attrs:{"text":_vm.title}}),_vm._v(" "),_c('div',{staticClass:"chart"},[_c('GChart',{ref:_vm.id,attrs:{"settings":{ packages: ['corechart', 'gauge'] },"type":"Gauge","data":_vm.chartData,"options":_vm.chartOptions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }